export const generateTestIdByDomain = (domainName: string) => ({
  button: (testId: string) => `${domainName}-button-${testId}`,
  input: (testId: string) => `${domainName}-input-${testId}`,
  select: (testId: string) => `${domainName}-select-${testId}`,
  img: (testId: string) => `${domainName}-img-${testId}`,
  div: (testId: string) => `${domainName}-div-${testId}`,
});
